import { useState } from 'react';
import { supabase } from '../supabase';

function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);

  const handleLogin = async () => {
    setCarregando(true);
    setErro('');
    const { error } = await supabase.auth.signInWithPassword({ email, password: senha });
    if (error) {
      setErro('Email ou senha incorretos.');
      setCarregando(false);
    } else {
      onLogin();
    }
  };

  return (
    <div className="min-h-screen flex" style={{ backgroundColor: '#0a0a0a' }}>
      {/* Lado esquerdo — branding */}
      <div className="hidden lg:flex w-1/2 flex-col justify-between p-12" style={{ backgroundColor: '#111111', borderRight: '1px solid #1a1a1a' }}>
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center font-bold text-black text-lg" style={{ backgroundColor: '#CCFF00' }}>
            A
          </div>
          <div>
            <span className="text-white text-xl font-bold tracking-wide">atris</span>
            <p className="text-xs tracking-widest" style={{ color: '#666' }}>PERFORMANCE DIGITAL</p>
          </div>
        </div>

        <div>
          <h1 className="text-5xl font-bold text-white leading-tight mb-6">
            Gestão financeira<br />
            <span style={{ color: '#CCFF00' }}>inteligente</span><br />
            para sua agência.
          </h1>
          <p className="text-lg" style={{ color: '#666' }}>
            Receitas, despesas, clientes e fluxo de caixa — tudo em um só lugar.
          </p>
        </div>

        <div className="flex gap-10">
          {[
            { valor: '12+', label: 'Clientes ativos' },
            { valor: 'R$ 18k', label: 'Receita mensal' },
            { valor: '100%', label: 'Controle total' },
          ].map(({ valor, label }) => (
            <div key={label}>
              <p className="text-2xl font-bold text-white">{valor}</p>
              <p className="text-sm mt-1" style={{ color: '#666' }}>{label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Lado direito — formulário */}
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          {/* Logo mobile */}
          <div className="flex items-center gap-3 mb-10 lg:hidden">
            <div className="w-10 h-10 rounded-xl flex items-center justify-center font-bold text-black text-lg" style={{ backgroundColor: '#CCFF00' }}>
              A
            </div>
            <span className="text-white text-xl font-bold">atris</span>
          </div>

          <div className="mb-8">
            <h2 className="text-3xl font-bold text-white">Bem-vindo de volta</h2>
            <p className="mt-2" style={{ color: '#666' }}>Entre com suas credenciais para acessar o painel.</p>
          </div>

          <div className="space-y-5">
            <div>
              <label className="block text-sm font-medium mb-2" style={{ color: '#888' }}>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleLogin()}
                placeholder="seu@email.com"
                className="w-full text-white rounded-xl px-4 py-3 outline-none transition-all"
                style={{ backgroundColor: '#1a1a1a', border: '1px solid #2a2a2a', color: 'white' }}
                onFocus={(e) => e.target.style.borderColor = '#CCFF00'}
                onBlur={(e) => e.target.style.borderColor = '#2a2a2a'}
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-2" style={{ color: '#888' }}>Senha</label>
              <input
                type="password"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleLogin()}
                placeholder="••••••••"
                className="w-full text-white rounded-xl px-4 py-3 outline-none transition-all"
                style={{ backgroundColor: '#1a1a1a', border: '1px solid #2a2a2a', color: 'white' }}
                onFocus={(e) => e.target.style.borderColor = '#CCFF00'}
                onBlur={(e) => e.target.style.borderColor = '#2a2a2a'}
              />
            </div>

            {erro && (
              <div className="rounded-xl px-4 py-3" style={{ backgroundColor: 'rgba(255,50,50,0.1)', border: '1px solid rgba(255,50,50,0.3)' }}>
                <p className="text-red-400 text-sm">{erro}</p>
              </div>
            )}

            <button
              onClick={handleLogin}
              disabled={carregando}
              className="w-full font-bold rounded-xl px-4 py-3.5 transition-all text-black"
              style={{ backgroundColor: carregando ? '#999' : '#CCFF00' }}
            >
              {carregando ? 'Entrando...' : 'Entrar →'}
            </button>
          </div>

          <p className="text-center text-sm mt-8" style={{ color: '#444' }}>
            Atris Performance Digital © 2026
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;